import { render } from "./IconEditPencil.vue?vue&type=template&id=7d0108a6"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconEditPencil.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d0108a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d0108a6', __exports__)) {
    api.reload('7d0108a6', __exports__)
  }
  
  module.hot.accept("./IconEditPencil.vue?vue&type=template&id=7d0108a6", () => {
    api.rerender('7d0108a6', render)
  })

}


export default __exports__